import { GalleryGridSizes } from "./GalleryGridSizes";

export const galleryChildrenComputed = {
  computed: {
    /**
     * Map backend given name to class name
     */
    gridSpanClass() {
      return this.isNestedModule
        ? GalleryGridSizes[this.module.config.general.blockWidth.value]
        : {};
    },
  },
};
